module.exports = __webpack_public_path__ + "static/media/page08.13905691.jpg";